import {z} from 'zod'
import {createPartialStrictObjectSchemaWithAtLeastOneProperty} from './PartialStrictObjectSchema.ts'
import {PlayerColor} from './PlayerState.ts'
import {validateState} from './ValidateState.ts'

export enum TurnState {
    InitialPlacement = 0,
    Dice = 1,
    Turn = 2,
    GameEnd = 3,
    SpecialBuildPhase = 4,
}

export enum ActionState {
    None = 0,
    InitialPlacementPlaceSettlement = 1,
    InitialPlacementPlaceCity = 2,
    InitialPlacementRoadPlacement = 3,
    PlaceRoad = 4,
    PlaceRoadForFree = 5,
    PlaceSettlement = 6,
    PlaceCity = 7,
    PlaceCityWithDiscount = 8,
    PlaceShip = 9,
    PlaceShipForFree = 10,
    SelectShipToMove = 11,
    MoveShip = 12,
    PlaceCityWall = 13,
    PlaceCityWallForFree = 14,
    PlaceKnight = 15,
    PlaceKnightForFree = 16,
    UpgradeKnight = 17,
    UpgradeKnightForFree = 18,
    ActivateKnight = 19,
    SelectKnightToTakeAction = 20,
    SelectKnightAction = 21,
    MoveKnightOffTurn = 22,
    SelectKnightToRemove = 23,
    PlaceRobberOrPirate = 24,
    PlaceRobberOnly = 25,
    PlacePirateOnly = 26,
    SelectWhoToRob = 27,
    SelectCardsToDiscard = 28,
    SelectProgressCardsToDiscard = 29,
    Place2MoreRoadBuilding = 30,
    Place1MoreRoadBuilding = 31,
    Select2ResourcesForYearOfPlenty = 32,
    Select1ResourceForMonopoly = 33,
    SelectCardsForPendingDistributions = 34,
    PlaceMetropolis = 35,
    SelectProgressCard = 36,
    SelectCityToPillage = 37,
    PlaceMerchant = 38,
    SelectDiceForAlchemist = 39,
    SelectTileProductionNumbersToSwap = 40,
    SelectPlayerForDeserter = 41,
    SelectRoadToRemove = 42,
    DiplomatSelectWhetherToPlaceNewEdgePiece = 43,
    IntrigueSelectKnightToMove = 44,
    SpySelectPlayer = 45,
    SpySelectProgressCard = 46,
    SelectCardsForWedding = 47,
    CommercialHarborSelectPlayerAndResource = 48,
    CommercialHarborOpponentSelectsCard = 49,
    MasterMerchantSelectPlayer = 50,
    MasterMerchantSelectCards = 51,
    MerchantFleetSelectResource = 52,
    ResourceMonopolySelectResource = 53,
    CommodityMonopolySelectResource = 54,
}

export const currentStateSchema = z
    .object({
        completedTurns: z.number().int().min(0),
        turnState: z.enum(TurnState),
        /**
         * @deprecated Using this field will break Colonist Rush. Use currentStateValidator.getPlayerActionState() instead
         */
        actionState: z.enum(ActionState),
        /**
         * @deprecated Using this field will break Colonist Rush. Use currentStateValidator.currentTurnPlayers instead
         */
        currentTurnPlayerColor: z.enum(PlayerColor),
        startTime: z.number().min(0),
        allocatedTime: z.number().min(0),
    })
    .strict()

export type CurrentState = z.infer<typeof currentStateSchema>

export function validateCurrentState(data: unknown) {
    return validateState(currentStateSchema, data)
}

export const currentStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(currentStateSchema)

export type CurrentStatePartial = z.infer<typeof currentStatePartialSchema>

export function validateCurrentStatePartial(data: unknown) {
    return validateState(currentStatePartialSchema, data)
}
